import React from 'react'

const ITNewsFeed = (props) => {
  const { domainSettings } = props
  if (!props.newsFeed) return null
  return props.newsFeed.map((item, key) => {
    const date = new Date(item.date).toString().split(/:\d\d /)
    if (!item.description || !item.link || !item.title) return null
    return (
      <div key={key} className='panel panel-primary'>
        <div className='panel-body'>
          {item.image && (
            <img className='img-responsive' src={item.image} />
          )}
          <h3 className='mb-0 product-title'>
            <a href={(['staging.holidayextras.com', 'www.holidayextras.com'].indexOf(domainSettings.domain) !== -1) ? '/' + domainSettings.language + item.link : item.link}
              data-toggle='modal.pane'
              dangerouslySetInnerHTML={{ __html: item.title }}
            />
          </h3>
          <p className='small text-muted mb-0 product-description' dangerouslySetInnerHTML={{ __html: item.description }} />
          {date[1] && (
            <p className='small text-muted'>{date[0]}</p>
          )}
        </div>
      </div>
    )
  })
}

export default ITNewsFeed



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/content/itNewsFeed.jsx